import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { labels } from "../../../../../localization/labels";
import KnowledgeType from "./type";
import KnowledgeSource from "./source";
import KnowledgeCopyright from "./copyright";
import { constants } from "../../../../../utils/Constants";
import SecurityUtil from "../../../../../utils/SecurityUtils";

const KnowledgeAdministration = props => {
  return (
    <div className="container">
      <Tabs
        id="km_know_admin_id"
        className="tabVerticalSize"
        mountOnEnter
        unmountOnExit
      >
        {SecurityUtil.renderElementByPermissions(
          <Tab eventKey="knowledgeType" title={labels.knowledgeType}>
            <KnowledgeType
              messageHandler={props.messageHandler}
              breadcrumbsHandler={props.breadcrumbsHandler}
            />
          </Tab>,
          [constants.OPERATION_KNOWLEDGE_ADMINISTRATION]
        )}
        {SecurityUtil.renderElementByPermissions(
          <Tab eventKey="knowledgeSource" title={labels.knowledgeSource}>
            <KnowledgeSource
              messageHandler={props.messageHandler}
              breadcrumbsHandler={props.breadcrumbsHandler}
            />
          </Tab>,
          [constants.OPERATION_KNOWLEDGE_ADMINISTRATION]
        )}
        {SecurityUtil.renderElementByPermissions(
          <Tab eventKey="knowledgeCopyright" title={labels.knowledgeCopyright}>
            <KnowledgeCopyright
              messageHandler={props.messageHandler}
              breadcrumbsHandler={props.breadcrumbsHandler}
            />
          </Tab>,
          [constants.OPERATION_KNOWLEDGE_ADMINISTRATION]
        )}
      </Tabs>
    </div>
  );
};

export default KnowledgeAdministration;
